import React from "react";
function PartTwo(props) {
  return (
    <div className="text-left">
      {props.backImage && (
        <img src={props.backImage} alt={props.customer.FirstName} />
      )}
    </div>
  );
}
export default PartTwo;
